import React, { useState } from "react";
import PropTypes from "prop-types";
import { getFormattedAddress } from "../layout/utils";
import { useTranslate } from "../../translate";
import AtlasCard from "./AtlasCard";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { motionTransition } from "./AtlasMenu";
import AtlasStopModal from "./AtlasStopModal";
import AtlasTerms from "./AtlasTerms";

export const popupVariants = {
    open: {
        opacity: 1,
        translateY: 0,
    },
    closed: {
        opacity: 0,
        translateY: 100,
    },
};

function AtlasStops(props) {
    const { className, stops, activeStopId, handleFavoriteClick, favoriteIds, stopsById, style } = props;
    const translate = useTranslate();
    const [mapStopId, setMapStopId] = useState(null);
    const closeModal = () => setMapStopId(null);
    const handleMapBtnClick = stopId => setMapStopId(stopId);
    const mapStop = stopsById[mapStopId];

    return (
        <div className={className} style={style}>
            {createPortal(
                <AnimatePresence initial={true}>
                    {mapStopId && (
                        <motion.div
                            onClick={closeModal}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={motionTransition}
                            className="trpr__route-explorer-overlay"
                            style={{ zIndex: 6 }}
                        />
                    )}
                </AnimatePresence>,
                document.querySelector("#portal"),
            )}
            <div
                style={{
                    left: 0,
                    position: "fixed",
                    bottom: 0,
                    width: "100%",
                    zIndex: 7,
                }}
            >
                <AnimatePresence>
                    {mapStopId !== null && (
                        <motion.div
                            variants={popupVariants}
                            initial="closed"
                            animate="open"
                            exit="closed"
                            transition={motionTransition}
                        >
                            <AtlasStopModal
                                closeModal={closeModal}
                                stop={mapStop}
                                title={translate(mapStop, "name")}
                                address={getFormattedAddress(mapStop.address)}
                                website={mapStop.website}
                                phone={mapStop.phone.yearRoundPhone}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
            {stops.map(stop => {
                return (
                    <AtlasCard
                        key={stop.id}
                        order={stop.order}
                        className="js__stop-card"
                        isActive={activeStopId === stop.id}
                        isFavorite={favoriteIds.includes(stop.id)}
                        description={translate(stop, "description")}
                        title={translate(stop, "name")}
                        address={getFormattedAddress(stop.address)}
                        website={stop.website}
                        phone={stop.phone.yearRoundPhone}
                        coords={stop.coords}
                        img={stop.image.medium2x}
                        onFavoriteBtnClick={handleFavoriteClick}
                        onMapBtnClick={handleMapBtnClick}
                        businessType={translate(stop, "type")}
                        stopId={stop.id}
                        itinerariesUrls={stop.relatedItineraries}
                    />
                );
            })}
            <AtlasTerms></AtlasTerms>
        </div>
    );
}

AtlasStops.propTypes = {
    stops: PropTypes.array,
};

export default AtlasStops;
